import type { TSliceReducer } from 'core/store';
import type { IMaintenanceState } from './types';

const resetMaintenanceForm: TSliceReducer<IMaintenanceState> = state => {
  state.form.loading = false;
  state.form.success = false;
};

const resetMaintenanceModal: TSliceReducer<IMaintenanceState> = state => {
  state.modal.loading = false;
  state.modal.success = false;
};

export const reducers = {
  resetMaintenanceForm,
  resetMaintenanceModal,
};
